import { useTexture } from '@react-three/drei';
import { extend, useFrame } from '@react-three/fiber';
import React, { useMemo, useRef } from 'react';
import * as THREE from 'three';
import { Water } from 'three/addons/objects/Water.js';

extend({ Water });

useTexture.preload('/waterNormals.jpeg'); // Preload texture globally

export default function Ocean() {
  const ref = useRef();

  // Load water normals texture
  const waterNormals = useTexture('/waterNormals.jpeg');
  if (!waterNormals) {
    console.error('Failed to load waterNormals texture.');
    return null; // Return early if texture loading fails
  }
  waterNormals.wrapS = waterNormals.wrapT = THREE.RepeatWrapping;

  // Water configuration
  const config = useMemo(() => ({
    textureWidth: 128,
    textureHeight: 128,
    waterNormals,
    sunDirection: new THREE.Vector3(4,0,0),
    waterColor:0x607888,
    fog: false,
}), [waterNormals]);

  // Geometry for the water plane
  const geometry = useMemo(() => new THREE.PlaneGeometry(70, 70), []);
  useFrame((state, delta) => {
    const material = ref.current.material ;
    material.uniforms.time.value += delta*.03;
})


  return (
    <water
      ref={ref}
      args={[geometry, config]} // Reuse memoized geometry and config
      rotation-x={-Math.PI / 2}
      position={[0, -0.06, 0]}
      frustumCulled={true} // Ensure Three.js's native culling is enabled
    />
  );
}
